import { PanelResultDetails } from "../../store/slices/order/types";
import ResultValue from "./ResultValueComponent";
import TestResultRanges from "./TestResultRanges";
import GreenBall from "../../assets/img/result/green-ball.svg";
import OrangeBall from "../../assets/img/result/orange-ball.svg";
import { ResultValueType } from "../../enums/result-value-type.enum";
import { getPanelResulItemStatus } from "../../utils/result.utils";
import { ResultStatus } from "../../enums/resultStatus.enum";
import CultureResult from "./CultureResult";
import { RenderRichText } from "../base";

const TestResultRow = ({
  resultDetails,
}: {
  resultDetails: PanelResultDetails;
}) => {
  const resultStatus = getPanelResulItemStatus(resultDetails);

  return (
    <>
      {resultDetails.valueType === ResultValueType.Culture ? (
        <CultureResult resultDetails={resultDetails} />
      ) : (
        <tr className="p-4 border-b border-b-[#E7E9EB] bg-white">
          <td className="py-6 px-4 lg:w-1/3">
            <div className="flex items-center">
              {resultStatus === ResultStatus.Good ? (
                <img src={GreenBall} alt="green dot icon" className="w-4 h-4" />
              ) : resultStatus === ResultStatus.Abnormal ? (
                <img
                  src={OrangeBall}
                  alt="orange dot icon"
                  className="w-4 h-4"
                />
              ) : null}
              <p className="pl-4 text-left text-[15px] font-[500]">
                <RenderRichText content={resultDetails?.name} />
              </p>
            </div>
          </td>
          <td className="py-6 px-4 lg:w-1/3">
            <ResultValue resultDetails={resultDetails} />
          </td>
          <td className="py-6 px-4 lg:w-1/3">
            <TestResultRanges resultDetails={resultDetails} />
          </td>
        </tr>
      )}
    </>
  );
};

export default TestResultRow;
